import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './locales';
import moment from 'moment-timezone';
import 'blueimp-canvas-to-blob';
import api from './services/api';
import { abilitiesPlugin } from '@casl/vue';
import { Can } from '@casl/vue';
import { Ability } from '@casl/ability';
import notify from './services/notifications';
import ability from './services/ability';

import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import TextHelpersPlugin from './plugins/textHelpers';

const app = createApp(App);
app.use(router);
app.use(store);
app.use(i18n);
app.use(abilitiesPlugin, ability, { useGlobalProperties: true });
app.use(VueTippy);
app.use(TextHelpersPlugin);
Object.defineProperty(app.config.globalProperties, '$moment', {
  get() {
    // Track the UI locale in every render that formats a date, including utc().
    moment.locale(i18n.global.locale);
    return moment;
  },
});
app.config.globalProperties.$http = api;
app.config.globalProperties.$notify = notify;
app.component('Can', Can);
app.mount('#app');
